import { render, staticRenderFns } from "./PcPreview.vue?vue&type=template&id=616f5c5f&scoped=true&"
import script from "./PcPreview.vue?vue&type=script&lang=js&"
export * from "./PcPreview.vue?vue&type=script&lang=js&"
import style0 from "./PcPreview.vue?vue&type=style&index=0&id=616f5c5f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "616f5c5f",
  null
  
)

export default component.exports